import { render, staticRenderFns } from "./preAlert.vue?vue&type=template&id=214360c9&"
import script from "./preAlert.vue?vue&type=script&lang=js&"
export * from "./preAlert.vue?vue&type=script&lang=js&"
import style0 from "./preAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports